import { LocalizedTextDisplayModel } from '@/api/model-index';
import { AbschnittDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { ItemContext } from '@/core/models/itemcontext';
import { I18nService } from '@/core/services/i18nService';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'section-info',
  templateUrl: './section-info.component.html',
  styleUrls: ['./section-info.component.scss']
})
export class SectionInfoComponent {

  @Input() public overrideTitle: string | null = null;
  @Input() public overrideDescription: string | null = null;

  public get CurrentItemContext(): ItemContext {
    return this.portalContextService.CurrentItemContext;
  }

  public get CurrentSection(): AbschnittDisplayModel | null {
    if (this.CurrentItemContext) {
      let section: AbschnittDisplayModel | null = this.sectionService.current();

      let dispModel: AbschnittDisplayModel = new AbschnittDisplayModel();
      if (section) {
        dispModel.name = this.overrideTitle != null  ? this.overrideTitle : (this.GetSectionKurzTitel(section) || section.name);
        dispModel.infotext = this.overrideDescription != null ? this.StringToBothLocalizedText(this.overrideDescription) : section.infotext;
      }
      else
      {
        dispModel.name = this.overrideTitle;
        dispModel.infotext = this.overrideDescription != null  ? this.StringToBothLocalizedText(this.overrideDescription) : [];
      }
      return dispModel;
    }
    return null;
  }

  constructor(protected portalContextService: PortalContextService, protected sectionService: SectionService, protected languageservice: I18nService) {
  }

  public GetSectionKurzTitel(section: AbschnittDisplayModel){
    let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(section.kurzTitel);
    return title?.text ?? "";
  }

  public GetSectionInfoText(section: AbschnittDisplayModel){
    let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(section.infotext);
    return title?.text ?? "";
  }

  public StringToBothLocalizedText(instring: string){
    if (!instring)
      return;
    var texts: LocalizedTextDisplayModel[] = this.languageservice.supportedLanguages.map(lang => {
      let x = new LocalizedTextDisplayModel();
      lang = lang.split('-')[0]
      x.localeCode = lang;
      x.text = instring;
      return x;
    })
    
    return texts;
  }
}
